import * as types from './types';

export const deleteAccountRequest = (data) => ({ type: types.DELETE_ACCOUNT_REQUEST, data });
export const deleteAccountRequestFailure = (error) => ({ type: types.DELETE_ACCOUNT_REQUEST_FAILURE, error });
export const deleteAccountRequestSuccess = (data) => ({ type: types.DELETE_ACCOUNT_REQUEST_SUCCESS, data });

export const getAccountsRequest = (data) => ({ type: types.GET_ACCOUNTS_REQUEST, data });
export const getAccountsRequestFailure = (error) => ({ type: types.GET_ACCOUNTS_REQUEST_FAILURE, error });
export const getAccountsRequestSuccess = (data) => ({ type: types.GET_ACCOUNTS_REQUEST_SUCCESS, data });

export const updateAccountRequest = (data) => ({ type: types.UPDATE_ACCOUNT_REQUEST, data });
export const updateAccountRequestFailure = (error) => ({ type: types.UPDATE_ACCOUNT_REQUEST_FAILURE, error });
export const updateAccountRequestSuccess = (data) => ({ type: types.UPDATE_ACCOUNT_REQUEST_SUCCESS, data });

export const updateCalendarRequest = (data) => ({ type: types.UPDATE_CALENDAR_REQUEST, data });
export const updateCalendarRequestFailure = (error) => ({ type: types.UPDATE_CALENDAR_REQUEST_FAILURE, error });
export const updateCalendarRequestSuccess = (data) => ({ type: types.UPDATE_CALENDAR_REQUEST_SUCCESS, data });
